import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import css from './modal.scss'

const topStyle = {
  width: '100%',
  height: '400px',
  boxShadow: '0 6px 10px 0 rgba(0, 0, 0, 0.1)',
}

const leftStyle = {
  height: '100%',
  overflowY: 'hidden',
  width: 400,
  maxWidth: '85%',
}

const getModalStyle = (origin) => {
  switch (origin) {
    case 'left':
      return leftStyle
    case 'top':
    default:
      return topStyle
  }
}

const DrawerModal = ({
  trigger,
  children,
  show,
  onHide,
  origin,
  style,
  ...rest
}) => (
  <>
    {trigger}

    <Modal
      show={show}
      onHide={onHide}
      animation={false}
      dialogClassName={css.drawerModalDialog}
      style={{ ...getModalStyle(origin), ...style }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      {children}
    </Modal>
  </>
)

DrawerModal.propTypes = {
  style: PropTypes.object,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  trigger: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  origin: PropTypes.oneOf(['top', 'left']),
}

DrawerModal.defaultProps = {
  style: {},
  origin: 'top',
}

export default DrawerModal
